export default ({ faqs, id }) => {
	const newFaqs = [];
	faqs.forEach((faqCat) => {
		const newFaqCat = faqCat;
		newFaqCat.faqs = faqCat.faqs.filter(faq => faq.id !== id);
		newFaqs.push(newFaqCat);
	});
	return newFaqs;
}



// WEBPACK FOOTER //
// ./src/helpers/deleteFaqItemByUuid.js